export const operationsIconHandler = status => {
    switch (status) {
        case 3:
            return 'check-circle'
        case 1:
        case 7:
        case 10:
        case 11:
            return 'clock'
        case 8:
        case 5:
            return 'error'
        case 9:
            return 'warning'
    }
}

export const operationsClassesHandler = status => {
    switch (status) {
        case 3:
            return 'positive'
        case 1:
        case 7:
        case 10:
        case 11:
            return 'warning'
        case 5:
        case 8:
        case 9:
            return 'negative'
    }
}

export const mobilePaymentsIconHandler = status => {
    switch (status) {
        case 1:
            return 'status-check'
        case 2:
        case 4:
        case 6:
        case 7:
        case 8:
        case 9:
            return 'status-error'
        case 5:
        case 10:
        case 11:
            return 'status-clock'
    }
}

export const mobilePaymentsClassesHandler = status => {
    switch (status) {
        case 1:
            return 'positive'
        case 2:
        case 4:
        case 6:
        case 7:
        case 8:
        case 9:
            return 'negative'
        case 5:
        case 10:
        case 11:
            return 'warning'
    }
}

export const tmxIconHandler = status => {
    switch (status) {
        case 'C':
            return 'check-circle'
        case 'A':
            return 'error'
        default:
            return 'clock'
    }
}

export const tmxClassesHandler = status => {
    switch (status) {
        case 'C':
            return 'positive'
        case 'A':
            return 'negative'
        default:
            return 'warning'
    }
}
